<template>
    <div>
        <unit></unit>
        <complete-service></complete-service>
        <complete-defect></complete-defect>
    </div>
</template>
<script>
import Unit from '@/components/Units/Details.vue';
import CompleteService from '@/components/Services/CompleteService.vue';
import CompleteDefect from '@/components/DefectNotices/CompleteDefect.vue';

export default {
    components: {
        Unit,
        CompleteService,
        CompleteDefect
    }
};
</script>
